<template>
	<div class="event-list-item-single">
		<div class="event-list-item-single__title">
			{{ title }}
		</div>
	</div>
</template>

<script>
export default {
	name:  'EventListItemSingleContent',
	props: {
		title: {
			type:     String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.event-list-item-single {
	display: flex;
	flex-grow: 1;
	flex-direction: column;
	gap: $sp3;
	padding-top: $sp1;
	padding-bottom: $sp1;
	text-align: left;

	@include size(md-up) {
		text-align: center;
	}
}

.event-list-item-single__title {
	@include font(primary, medium, normal, fs-80);
	@include line-clamp(2);
	max-width: 100%;
	color: var(--color-white);

	body.-t-light & { // stylelint-disable-line selector-no-qualifying-type
		color: var(--color-black);
	}
}
</style>
